import React from 'react';
import Valedictionceremony2023 from 'views/Valedictionceremony2023'

const SchoolProgrampage = () => {
  return <Valedictionceremony2023 />;
};

export default SchoolProgrampage;